import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "../../core";
import { environment } from "environments/environment";
import { InterfaceResponse } from "./response/interface.response";

@Injectable({ providedIn: 'root' })
export class InterfaceService extends BaseService {
  private interfaceEndpoint = `${environment.urlEdducaImobApi}EdducaImobCore/Interface/`;

  constructor(private http: HttpClient) {
    super();
  }

  obtemInterfaceUsuario(usuarioId: number): Observable<InterfaceResponse[]> {
    return this.http.get<InterfaceResponse[]>(
      `${this.interfaceEndpoint}ObtemInterfaceUsuario/${usuarioId}`, {headers: this.getHeader(false)});
  }

}